<template>
<div class="airlineplacementform">
  <div class="airlineplacementform__header">
    <h1 v-if="isEdit" class="medium-title">Edit Placement</h1>
    <h1 v-else class="medium-title">Add New Placement</h1>
  </div>
  <div class="airlineplacementform__body" v-if="!isLoadingPage">
    <div class="airlineplacementform__body__left">
      <div class="airlineplacementform__body__left__container">
        <div class="airlineplacementform__body__left__container__item">
          <adx-single-search-dropdown :label="`Media`" :optionsParam="mediaOptions" :value.sync="model.media" :loading="isLoadingForm"
            :size="'size'" :ref="vuelidateOptions.media.ref" :error.sync="vuelidateOptions.media.error"/>
        </div>
      </div>
      <div class="airlineplacementform__body__left__container">
        <h1 class="subhead title">General Information</h1>
        <div class="airlineplacementform__body__left__container__item">
          <adx-input :label="`Placement Name`" :value.sync="model.placementName" :inputId="`placementName`"
            :ref="vuelidateOptions.placementName.ref" :error.sync="vuelidateOptions.placementName.error"/>
        </div>
        <div class="airlinemediaform__body__left__container__item">
          <adx-textarea :label="`Description`" :value.sync="model.description" 
            :ref="vuelidateOptions.description.ref" :error.sync="vuelidateOptions.description.error"/>
        </div>
      </div>
      <div class="airlineplacementform__body__left__container">
        <h1 class="subhead title">Item Price</h1>
        <div class="airlineplacementform__body__left__container__item">
          <adx-input :frontIcon="`rupiah`" :label="`Public price`" :value.sync="model.publicPrice" :isNumberOnly="true" :inputId="`publicPrice`"
            :ref="vuelidateOptions.publicPrice.ref" :error.sync="vuelidateOptions.publicPrice.error"/>
          <adx-input :frontIcon="`rupiah`" :label="`Bottom price`" :value.sync="model.bottomPrice" :isNumberOnly="true" :inputId="`bottomPrice`"
            :ref="vuelidateOptions.bottomPrice.ref" :error.sync="vuelidateOptions.bottomPrice.error"/>
        </div>
      </div>
      <div class="airlineplacementform__body__left__container">
        <h1 class="subhead title">Stock Availabity</h1>
        <div class="airlineplacementform__body__left__container__item">
          <adx-input :label="`Quantity`" :value.sync="model.stockQuantity" :isNumberOnly="true" :inputId="`quantity`"
            :ref="vuelidateOptions.stockQuantity.ref" :error.sync="vuelidateOptions.stockQuantity.error" />
          <adx-checkbox :label="`Set As Unlimited`" :value.sync="model.unlimited" :valueLabel="`unlimited`" class="maxcontent"/>
          <adx-checkbox :label="`Out Of Stock`" :value.sync="model.outOfStock" :valueLabel="`outoftock`" class="maxcontent"/>
        </div>
      </div>
      <div class="airlineplacementform__body__left__container">
        <h1 class="subhead title">Future Price</h1>
        <div v-for="(price, index) in model.futurePrices" :key="index+`price`" class="futureWrapper">
          <div class="calendarWrapper">
            <div class="airlineplacementform__body__left__container__item date">
              <div :class="[(vuelidateOptions.futurePrices.error[index].startDate) || (vuelidateOptions.futurePrices.error[index].endDate ) ? 'calendar warning' : 'calendar']"
                :ref="vuelidateOptions.futurePrices.ref.startDate">
                <div :ref="vuelidateOptions.futurePrices.ref.endDate"></div>
                <v-date-picker
                  v-model='price.startDate'
                  :popoverVisibility="`focus`"
                  :min-date="tomorrow"
                  :max-date='price.endDate? price.endDate : null'
                  :theme-styles='themeStyles'
                  :disabled-dates='listDisabledDate(price, index)'
                  class='date-picker'>
                  <div class="field"
                    slot-scope='{ inputValue, updateValue }'
                  >
                  <div class="start_date">
                    <label class="mini-font calendar-label">Start Date</label>
                    <input
                      class="date-picker-input"
                      type='text'
                      required
                      readonly
                      :value='inputValue? inputValue: `Unset`'
                      @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                      @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'/>
                  </div>
                  </div>
                </v-date-picker>
                <div class="arrow">
                  <i class="icon-arrow-forward"></i>
                </div>
                <v-date-picker
                  v-model='price.endDate'
                  :popoverVisibility="`focus`"
                  :min-date='price.startDate? price.startDate : tomorrow'
                  :theme-styles='themeStyles'
                  :max-date='selectMaxDate(price, index)'
                  :disabled-dates='listDisabledDate(price, index)'
                  class='date-picker'>
                  <div class="field"
                    slot-scope='{ inputValue, updateValue }'
                  >
                  <div class="end_date">
                    <label class="mini-font calendar-label">End Date</label>
                    <input
                      class="date-picker-input"
                      type='text'
                      readonly
                      :value='inputValue? inputValue: `Unset`'
                      @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                      @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
                  </div>
                  </div>
                  </v-date-picker>
              </div>
              <div
                v-if="vuelidateOptions.futurePrices.error[index].startDate || vuelidateOptions.futurePrices.error[index].endDate"
                class="small-font color-red"
              >{{vuelidateOptions.futurePrices.error[index].startDate || vuelidateOptions.futurePrices.error[index].endDate}}</div>
            </div>
            <div class="airlineplacementform__body__left__container__item">    
              <adx-input :frontIcon="`rupiah`" :label="`Public price`" :value.sync="price.futurePublicPrice" :isNumberOnly="true" :inputId="`futurePublicPrice_` + index"
                :error.sync="vuelidateOptions.futurePrices.error[index].futurePublicPrice" :ref="vuelidateOptions.futurePrices.ref.futurePublicPrice"/>
              <adx-input :frontIcon="`rupiah`" :label="`Bottom price`" :value.sync="price.futureBottomPrice" :isNumberOnly="true" :inputId="`futureBottomPrice_`+ index"
                :error.sync="vuelidateOptions.futurePrices.error[index].futureBottomPrice" :ref="vuelidateOptions.futurePrices.ref.futureBottomPrice"/>
            </div>
          </div>
          <div class="icon-wrapper"> <i @click="deleteFuturePrice(model.futurePrices, index)" class="icon-deleted color-grey"></i> </div>
        </div>
        <div class="line-wrapper">
          <hr class="line" />
        </div>
        <div class="addNewButton">
          <button @click="addFuturePrice" class="color-red">Add new</button>
        </div>
      </div>
      <div class="airlineplacementform__body__left__container">
        <h1 class="subhead title">Purchase restrictions</h1>
        <div class="airlineplacementform__body__left__container__item">
          <adx-input :label="`Minimum Period`" :value.sync="model.minimumPeriod" :inputId="`period`" :isNumberOnly="true"
           :ref="vuelidateOptions.minimumPeriod.ref" :error.sync="vuelidateOptions.minimumPeriod.error"/>
          <adx-select-dropdown :options="timeOption" :value.sync="model.planPeriod" class="dropdown maxcontent" />
        </div>
        <div class="airlineplacementform__body__left__container__item">
          <adx-input :label="`Minimum Quantity`" :value.sync="model.minQuantity" type="number" :isNumberOnly="true" :inputId="`quantity`"
            :ref="vuelidateOptions.minQuantity.ref" :error.sync="vuelidateOptions.minQuantity.error"/>
          <adx-input :label="`Lead Time`" :value.sync="model.leadTime" type="number" :isNumberOnly="true" :inputId="`leadtime`"
            :ref="vuelidateOptions.leadTime.ref" :error.sync="vuelidateOptions.leadTime.error" :icon="`day `"
            :tooltip="`a time period of the earliest campaign can be executed relative from order date. For example, if the lead time is 6 days,
                it means that if an advertisers order today, the campaign will run 6 days from today`" />
        </div>
        
      </div>
      <div class="airlineplacementform__body__left__container">
        <h1 class="subhead title">Images (Optional)</h1>
        <div v-for="(image, index) in model.images" :key="index" class="airlineplacementform__body__left__container__images" >
          <div class="airlineplacementform__body__left__container__images__image">
            <div class="upload-wrapper">
              <div class="top">
                <div v-if="image.imageUrl" class="file-image">
                  <img :src="image.imageUrl" />
                </div>
                <!-- <adx-progress-bar /> -->
                <div class="file-name">
                  <span class="image_name">
                    <label>{{image.caption}}</label>
                    <i v-if="image.caption" @click="cancelImage(index)" class="adx-ic_cancel"></i>
                  </span>
                </div>
              </div>
              <div class="bottom">
                <div>
                  <adx-checkbox :label="`Set as featured image`" :valueLabel.sync="image.isFeatured" :value.sync="image.isFeatured"
                    :inputId="index" @buttonClicked="buttonClicked(image)"/>
                </div>
                <div class="icon-wrapper">
                  <i @click="deleteImages(model.images, index)" class="icon-deleted"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-for="(image, index) in model.imagesNew" :key="index+'_new'" class="airlineplacementform__body__left__container__images" >
          <div class="airlineplacementform__body__left__container__images__image">
            <div class="upload-wrapper">
              <div class="top">
                <div v-if="image.imageUrl" class="file-image">
                  <img :src="image.imageUrl" />
                </div>
                <!-- <adx-progress-bar /> -->
                <div class="file-name">
                  <span class="image_name">
                    <label>{{image.caption}}</label>
                    <i v-if="image.caption" @click="cancelImage(index)" class="adx-ic_cancel"></i>
                  </span>
                  <div class="image_status" v-if="imageLoadings[index] != null">
                    <span class="is_loading" v-if="imageLoadings[index]">Loading...</span>
                    <span class="is_success" v-if="!imageLoadings[index] && image.isSuccess">Uploaded</span>
                    <span class="is_error" v-if="!imageLoadings[index] && !image.isSuccess">Error</span>
                  </div>
                </div>
              </div>
              <div class="bottom">
                <div>
                  <adx-checkbox :label="`Set as featured image`" :valueLabel.sync="image.isFeatured" :value.sync="image.isFeatured"
                    :inputId="index+'_new'" @buttonClicked="buttonClicked(image)"/>
                </div>
                <div class="icon-wrapper">
                  <i @click="deleteImages(model.imagesNew, index)" class="icon-deleted"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="airlineplacementform__body__left__container__item upload">
            <!-- <div class="airlineplacementform__body__left__container__item"> -->
              <input type="file" accept=".jpg, .jpeg, .png, .zip, .rar, .pdf, .psd, .ai, .eps, .cdr" @change="getFileImage($event)"
                :ref="`fileUpload`" style="display: none;">
              <div class="browse" @click="launchFilePicker">
                <span class="title">Browse file to upload</span>
                <span class="description">Allowed file type zip, rar, pdf, psd, ai, eps, jpg, png, eps and cdr. Maximum size 1GB</span>
              </div>
            <!-- </div> -->
          </div>
      </div>
    </div>
    <div class="airlineplacementform__body__right">
      <div class="airlineplacementform__body__right__container tags">
        <h1 class="subhead title">Tags ( Optional )</h1>
        <div class="airlineplacementform__body__left__container__item">
          <adx-input-tag :limit="tagLimit" v-model="model.tagsText" :value="model.tagsText" :placeholder="tagPlaceholder"  :add-tag-on-blur="addTagOnBlur"
          />
        </div>
      </div>
      <div class="button"><button class="btn-regular primary" @click="savePlacement" :disabled="saveLoading">Save <adx-loading-2 v-if="saveLoading" /></button></div>
    </div>
  </div>
  <adx-loading v-else/>
</div>
</template>


<script>
import api from "@/api"
import moment from 'moment'
import InputTag from "@/components/Form/InputTag";
import { required, minLength, maxLength, numeric, alphaNum, alpha, requiredIf } from 'vuelidate/lib/validators'
import { ACheckbox, AInput, ATextArea, ASingleSearchDropdown, ASelectDropdown, ALoadingPrimary, ALoadingSecondary} from "ui-kit-v1"

import { restEdge } from "@/api/edgeUrls"
import { mapListFilter } from '@/lib/transformer'
import { sizeConverter } from '@/lib/util'
import { globalMixins } from "@/lib/mixins/globalMixins";

import * as validationLib from "@/lib/validation/"
const { helpers, validate } = validationLib;

export default {
  name: 'adx-airline-placement-form',
  components: {
    "adx-input": AInput,
    "adx-input-tag": InputTag,
    "adx-select-dropdown": ASelectDropdown,
    "adx-textarea": ATextArea,
    "adx-checkbox": ACheckbox,
    "adx-single-search-dropdown": ASingleSearchDropdown,
    "adx-loading": ALoadingPrimary,
    "adx-loading-2": ALoadingSecondary,
  },
  mixins: [globalMixins],
  props: {},
  data() {
    return {
      addTagOnBlur: false,
      imageLoadings: [],
      isLoadingForm: false,
      isLoadingPage: false,
      isUpload:false,
      saveLoading: false,
      tagLimit: 100,
      tagPlaceholder: "Separate tags with comma",
      uploadSuccess: false,
      model: {
        tagsText: [],
        media: null,
        description: null,
        images: [],
        imagesNew: [],
        placementName: null,
        minQuantity: null,
        unlimited: false,
        outOfStock: false,
        minimumPeriod: null,
        planPeriod: "month",
        leadTime: null,
        publicPrice: null,
        bottomPrice: null,
        stockQuantity: null,
        futurePrices: [
          { 
            startDate: null,
            endDate: null,
            futurePublicPrice: null,
            futureBottomPrice: null,
          }
        ],
      },
      themeStyles: {
        dayContent: {
          fontSize: '15px',
        },
        headerTitle: {
          fontSize: '17px',
          fontWeight: 'bold'
        },
        weeks: {
          fontWeight: 'bold'
        },
        wrapper: {
          boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.16)',
          backgroundColor: 'white',
          border: 'none',
        },
        header: {
          marginBottom: '6px'
        },
      },
      mediaOptions: [],
      timeOption: [
        {
          id: 1,
          label: "Month",
          value: "month"
        },
      ],
      vuelidateOptions: {
        media: {
          error: null,
          ref: 'media'
        },
        placementName: {
          field: 'placement name',
          error: null,
          ref: 'placementName'
        },
        description: {
          error: null,
          ref: 'description'
        },
        minQuantity: {
          field: 'minimum quantity',
          error: null,
          ref: 'minQuantity'
        },
        minimumPeriod: {
          field: 'minimum period',
          error: null,
          ref: 'minimumPeriod'
        },
        leadTime: {
          field: 'lead time',
          error: null,
          ref: 'leadTime'
        },
        publicPrice: {
          field: 'public price',
          error: null,
          ref: 'publicPrice'
        },
        bottomPrice: {
          field: 'bottom price',
          error: null,
          ref: 'bottomPrice'
        },
        stockQuantity: {
          field: 'stock quantity',
          error: null,
          ref: 'stockQuantity'
        },
        futurePrices: {
          field: {
            startDate: 'start date',
            endDate: 'end date',
            futurePublicPrice: 'future public price',
            futureBottomPrice: 'future bottom price'
          },
          error: [
            {
              startDate: null,
              endDate: null,
              futurePublicPrice: null,
              futureBottomPrice: null
            }
          ],
          ref: {
            startDate: 'startDate',
            endDate: 'endDate',
            futurePublicPrice: 'futurePublicPrice',
            futureBottomPrice: 'futureBottomPrice'
          },
        },
      }
    }
  },
  validations: {
    model: {
      media: { required },
      placementName: { required, minLength: minLength(3), maxLength: maxLength(50) },
      description: { required, minLength: minLength(3) }, 
      publicPrice: { required, numeric },
      bottomPrice: { required, numeric },
      stockQuantity: { required, numeric },
      futurePrices: {
        $each: {
          startDate: { 
            requiredIf: requiredIf( obj => obj.endDate != null 
                  || obj.futurePublicPrice != null || obj.futureBottomPrice != null)
          },
          endDate: {},
          futurePublicPrice: { 
            requiredIf: requiredIf((obj) => obj.startDate != null || obj.futureBottomPrice != null)
          },
          futureBottomPrice: {
            requiredIf: requiredIf((obj) => obj.startDate != null || obj.futurePublicPrice != null)
          }
        }
      },
      minimumPeriod: { required, numeric },
      minQuantity: { required, numeric },
      leadTime: { required, numeric },
    },
  },
  computed: {
    isEdit: function(){
      this.id = this.$route.params.id
      return this.$route.params.id
    },
    nextweek() {
      var nextweek = new Date();
      nextweek.setDate(nextweek.getDate() + 7);
      return nextweek
    },
    tomorrow() {
      var tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      return tomorrow
    },
  },
  watch: {},
  beforeCreate() {},
  created() {},
  async beforeMount() {
    this.isLoadingPage = true
    await this.getMedia()
    if(this.isEdit){
      this.getPlacement()
    } else {
      this.isLoadingPage = false
    }
  },
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    listDisabledDate(price, index) {
      let dates = []
      let startDates = []
      this.model.futurePrices.map((x, idx) => {
        if (index != idx && x.startDate && x.endDate) {
          dates.push({
            start: new Date(x.startDate),
            end: new Date(x.endDate)
          })
        } else if (x.startDate) {
          dates.push(new Date(x.startDate))
        }
      })
      return dates
    },
    selectMaxDate(price, index){
      let disables = this.listDisabledDate(price, index)
      let min = 0
      let nearestFutureStartDate = null

      if (price.startDate) {
        disables.map((x, idx) => {
          let gap = x.start - price.startDate ;
          if (index != idx && x.start && gap > 0 && (min == 0 || gap < min)) {
            min = gap
            nearestFutureStartDate = x.start
          } 
        })
      }
      return nearestFutureStartDate
    },
    async buttonClicked(image) {
      await this.model.images.map(async x => {
        if (x.id !== image.id) x.isFeatured = await false;
      });
      await this.model.imagesNew.map(async x => {
        if (x.id !== image.id) x.isFeatured = await false;
      });
      
    },
    async getPlacement(){
      const {data, status} = await api.get(restEdge.adminAirlineGetPlacement(this.id), { needToken: true, useRestEdge: true });
      if (status == 200) {
        this.mapData(data)
      }
    },
    async getMedia(){
      this.isLoadingForm = true
      const {data, status} = await api.get(restEdge.adminAirlineMediaList, { needToken: true, useRestEdge: true });
      if (status == 200) {
          this.mediaOptions = mapListFilter({obj: data.results, id:`id`, value:`id`, label: `name`})
      }
      this.isLoadingForm = false
    },
    mapData(data){
      let tags = data.tags.map(x => x.name)

      this.model.media = data.airlinesMediaId
      this.model.tagsText = tags
      this.model.description = data.description
      this.model.placementName = data.name
      this.model.minQuantity = data.minQuantity
      this.model.unlimited = data.unlimited
      this.model.outOfStock = data.outOfStock
      this.model.minimumPeriod = data.minPeriod
      this.model.leadTime = data.leadPreCampaign
      this.model.publicPrice = data.publicPrice
      this.model.bottomPrice = data.bottomPrice
      this.model.stockQuantity = data.quantity
      this.model.images = data.airlinesContent.map(x => {
        return {
          imageUrl: x.imageUrl,
          caption: x.caption,
          isFeatured: x.isFeatured,
        }
      })
      let futures = []
      let errors = []

      for(let x of data.airlinesFuturePrice) {
        let price = {
          startDate: x.start? new Date(x.start): null,
          endDate: x.end? new Date(x.end): null,
          futurePublicPrice: x.publicPrice,
          futureBottomPrice: x.bottomPrice
        }
        futures.push(price)
        errors.push({
          startDate: null,
          endDate: null,
          futurePublicPrice: null,
          futureBottomPrice: null
        })
      }
      this.model.futurePrices = futures
      this.vuelidateOptions.futurePrices.error = errors
      this.isLoadingPage = false
    },
    async savePlacement(){
      this.saveLoading = true
      this.$v.$touch()
      this.nullableErrorFuturePrice()
      if (this.$v.model.$invalid) {
        const { key, message, element, collection } = helpers.vuelidateValidationHelper(this.$v.model, this.vuelidateOptions, this.$refs)
        if (collection) {
          this.vuelidateOptions[key].error[collection.index][collection.collectionKey] = message
        } else {
          this.vuelidateOptions[key].error = message
        }

        if (typeof element[0] == "undefined") {
          this.$nextTick(function() {
            element.scrollIntoView();
          });
        } else {
          this.$nextTick(function() {
            if (element[0].hasOwnProperty("$el")) {
              element[0].$el.scrollIntoView();
            } else {
              element[0].scrollIntoView();
            }
          });
        }
        this.saveLoading = false
      } else {
        let futurePrices = []
        let contents = this.model.images.concat(this.model.imagesNew)
        for(let x of this.model.futurePrices) {
          let price = {
            start: x.startDate ? new Date(x.startDate): null,
            end: x.endDate ? new Date(x.endDate): null,
            publicPrice: x.futurePublicPrice,
            bottomPrice: x.futureBottomPrice
          }
          futurePrices.push(price)
        }

        let form = {
          airlinesMediaId: this.model.media,
          tags: this.model.tagsText,
          description: this.model.description,
          name: this.model.placementName,
          minQuantity: this.model.minQuantity,
          unlimited: this.model.unlimited || false,
          outOfStock: this.model.outOfStock || false,
          minPeriod: this.model.minimumPeriod,
          minPeriodPlan: 'month',
          pricingPlan: 'month',
          leadPreCampaign: this.model.leadTime,
          publicPrice: this.model.publicPrice,
          bottomPrice: this.model.bottomPrice,
          quantity: this.model.stockQuantity,
          futurePrices: futurePrices,
          airlinesContent: contents,
          
        }

        if (this.isEdit) {
          const {data, status} = await api.put(restEdge.adminAirlineEditPlacement(this.id), form, {useRestEdge: true, needToken: true})
          this.afterSave(status)
          this.saveLoading = false
        } else {
          const {data, status} = await api.post(restEdge.adminAirlineCreatePlacement, form, {useRestEdge: true, needToken: true})
          this.afterSave(status)
          this.saveLoading = false
        }
      }
    },
    afterSave(status) {
      if (status == 200) {
        this.showNotificationAlert("Success", "Placement successfully saved!", "success");
        this.$router.push({name: `airlineplacement`})
      } else {
        this.showNotificationAlert("Error", "Oops data can not be saved!", "danger");
      }
    },
    launchFilePicker() {
      this.$refs.fileUpload.click();
    },
    async getFileImage(event) {
      let index = this.model.imagesNew.length
      this.imageLoadings.push(null);
      
      let input = event.target;
      if (input.files && input.files[0]) {
        let reader = new FileReader();
        let validated_data = this.validateImage(input.files[0]);
        if (!validated_data.is_valid) {
          this.showNotificationAlert("Error", "Image failed to uploaded. Try again!", "danger");
          this.uploadSuccess = false
          image.success = false
        } else {
          this.model.imagesNew.push({
            imageUrl: null,
            caption: null,
            name: null,
            image: null,
          })
          reader.onload = e => {
            image.imageUrl = e.target.result;
          };
          reader.readAsDataURL(input.files[0]);
          
          let image = this.model.imagesNew[index]
          image.caption = input.files[0].name;
          image.image = input.files[0];
          
          this.processFiles(input.files[0], image, index);
        }
      }
    },
    processFiles(files, image, index) {
      if (files) {
        let fileData = files

        //process
        let formData = new FormData();
        formData.append("file", fileData);
        formData.append("name", fileData.name);
        formData.append("caption", fileData.name);
        
        (async () => {

          this.$set(this.imageLoadings, index, true);
          const result = await api.post(restEdge.adminAirlineContent, formData, {
            needToken: true,
            useRestEdge: true,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });

          await this.$nextTick();
          if(result.status == 200 ) {
            let imageId = result.data.id
            let imageUrl = result.data.imageUrl
            image.id = imageId
            image.imageUrl = imageUrl
            image.image = null
            this.uploadSuccess = true
            image.isSuccess = true
          } else {
            this.showNotificationAlert("Error", "Image failed to uploaded. Try again!", "danger");
            this.uploadSuccess = false
            image.isSuccess = false
          }

          this.$set(this.imageLoadings, index, false);
        })();
      }
    },
    validateImage(file) {
      let maxSize = 300000; // 300kB
      let data = { is_valid: true }
      if (/image/.test(file.type)) {
        let image_ext_patt = new RegExp(/.jpg|.jpeg|.png/)
        if (!image_ext_patt.test(file.name.toLowerCase())) {
          data.is_valid = false
          data.message = 'Unsupported file type'
          return data
        }
      }
      if (file.size > maxSize) {
        data.is_valid = false
        data.message = `File shouldn't more than ${sizeConverter(maxSize)}`
        return data
      }
      const filename = file.name.split('.')[0]
      if (filename.length > 44) {
        data.is_valid = false
        data.message = 'File name is too long. Maximum size 44 character'
        return data
      }

      return data
    },
    deleteImages(image, index) {
      image.splice(index, 1);
      this.imageLoadings.splice(index, 1);
    },
    addFuturePrice(){
      this.model.futurePrices.push({
        startDate: null,
        endDate: null,
        futurePublicPrice: null,
        futureBottomPrice: null
      });
      this.vuelidateOptions.futurePrices.error.push({
        startDate: null,
        endDate: null,
        futurePublicPrice: null,
        futureBottomPrice: null
      })
    },
    deleteFuturePrice(price, index){
      price.splice(index, 1);
      this.vuelidateOptions.futurePrices.error.splice(index, 1)
    },
    nullableErrorFuturePrice(){
      let errors = []

      for(let x of this.model.futurePrices) {
        errors.push({ startDate: null, endDate: null, futurePublicPrice: null, futureBottomPrice: null })
      }
      this.vuelidateOptions.futurePrices.error = errors
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>

<style lang='scss'>
.airlineplacementform {
  .vue-input-tag-wrapper .new-tag {
    margin-top: 0px;
  }

  .input-tag {
    max-height: 20px;
  }

  .frontIcon {
    max-width: 20px;
  }
  .selectDropdown .select input {
    min-height: 63px !important;
  }
  .input input {
    min-height: 63px !important;
  }

  .tooltip {
  position: absolute;
  top: 23px;
  right: 9px;

  &.top {
    .tooltiptext {
      min-width: 240px;
      // padding: 20px 0;
      padding: 16px;
      text-align: left;
    }
  }
}
}
</style>
